import { api } from "../../config/axios";
import IResponseBody from "../../interfaces/response-body";
import { IEnvironment } from "../../models/environment";
import {environments} from "../../config/environments";
import IRoutineRequestTO from "../../interfaces/routine-request-to";

export const recapRoutine = async (
  env: IEnvironment,
  rtn: IRoutineRequestTO
): Promise<IRoutineRequestTO[] | undefined> => {
  const response = await api.post<IResponseBody<IRoutineRequestTO[]>>(
    environments.url_rotina + `/dashboard/list/${env.id}`, rtn
  );
  return response.data.data;
};

export const recapImmediate = async (
  env: IEnvironment,
): Promise<[] | undefined> => {
  const response = await api.post<IResponseBody<[]>>(
    environments.url_rotina + `/dashboard/execute-immediate/${env.id}`
  );
  return response.data.data;
};

export const recapScheduled = async (
  env: IEnvironment,
): Promise<[] | undefined> => {
  const response = await api.post<IResponseBody<[]>>(
    environments.url_rotina + `/dashboard/execute-scheduled/${env.id}`
  );
  return response.data.data;
};

export default {recapRoutine, recapImmediate, recapScheduled };
